module.exports = "/assets/16580c9eb327ce6b993afd51ed1f91b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MY.png
// module id = 2755
// module chunks = 0